module.exports = __webpack_public_path__ + "static/media/youtube.960d3cdf.svg";